/* HomeKind conversion helpers: sticky bar, upsell row, kit deadline countdown,
   guarantee line, cart shipping line. ES5, single install, fully guarded.

   HARD RULE: nothing here may trigger itself. No MutationObserver, no fetching
   timer, and this file never dispatches cart:update, it only listens. Every cart
   read passes through readCart(), which is re-entrant safe and capped per page.

   8 Aug: added the upsell row. When the cart holds exactly one single bottle the
   main button reads "Go to checkout" and the row above it offers the second
   bottle, which is where the pack price and free shipping actually come from.
   Filename carries -v2 because asset_url kept serving a stale fingerprint. */
(function () {
  "use strict";
  if (window.__hkCro) return;
  window.__hkCro = true;
  window.HK_CRO_VER = "2026-08-09a";

  var DEADLINE_UTC = Date.UTC(2026, 7, 14, 13, 59, 0); /* Fri 14 Aug 23:59 AEST */
  var FREE_SHIP_CENTS = 7000;
  /* Runaway backstop only. Raised from 12: the upsell adds a legitimate round of
     reads (add, swap, re-check) on top of boot and the drawer, and a shopper who
     changes their mind twice was hitting the old ceiling and freezing the bar. */
  var MAX_CART_READS = 24;
  var cartReads = 0;
  var reading = false;
  var lastCart = null;

  function track(n) { try { if (window.fbq) window.fbq("trackCustom", n); } catch (e) {} }

  function money(cents) {
    var s = (Math.round(cents) / 100).toFixed(2);
    return "$" + s.replace(/\.00$/, "");
  }

  /* The only place this file talks to the network. */
  function readCart(cb) {
    if (reading) return;
    if (cartReads >= MAX_CART_READS) return;
    reading = true; cartReads++;
    fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (cart) { reading = false; if (cart) { lastCart = cart; cb(cart); } })
      .catch(function () { reading = false; });
  }

  /* ---------- countdown (text only, never fetches) ---------- */
  function countdownText() {
    var ms = DEADLINE_UTC - new Date().getTime();
    return null;   /* the launch countdown is retired; the offer it named no longer exists */
    var d = Math.floor(ms / 86400000);
    var h = Math.floor((ms % 86400000) / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    /* Minutes throughout, and seconds inside the last day. "6d 7h" barely moves,
       which reads as decoration rather than a deadline. */
    var sec = Math.floor(ms / 1000) % 60;
    if (d > 0) return "" + d + "d " + h + "h " + m + "m left";
    if (h > 0) return "" + h + "h " + m + "m " + sec + "s left";
    return "" + m + "m " + sec + "s left";
  }
  /* Styled from here rather than hk-cro.css: asset fingerprints on this store
     get stuck for hours and this did not warrant cutting a new stylesheet. */
  function countStyles() {
    if (document.getElementById("hk-count-css")) return;
    var s = document.createElement("style");
    s.id = "hk-count-css";
    s.textContent =
      ".hk-count{display:inline-block;margin:6px 0 0;padding:5px 11px;border-radius:999px;" +
      "background:rgba(180,60,40,.09);color:#B43C28;font-size:13px;font-weight:600;line-height:1.3}" +
      ".hk-cartextras{display:flex;flex-direction:column;align-items:center;gap:10px;margin:14px 0}" +
      ".hk-shipline{margin:0;font-size:13px;text-align:center}" +
      ".hk-count{margin:0}" +
      ".hk-shipline s{opacity:.6}";
    document.head.appendChild(s);
  }
  function renderCounts() {
    countStyles();
    var text = countdownText();
    var els = document.querySelectorAll(".hk-count");
    for (var i = 0; i < els.length; i++) {
      if (text === null) { if (els[i].parentNode) els[i].parentNode.removeChild(els[i]); }
      else if (els[i].textContent !== text) els[i].textContent = text;
    }
  }

  /* ---------- product page: guarantee + kit note + countdown ---------- */
  function productInserts() {
    var f = document.querySelector('form[action*="/cart/add"]');
    if (!f || document.getElementById("hk-guarantee")) return;
    var wrap = document.createElement("div");
    wrap.id = "hk-guarantee";
    wrap.innerHTML =
      '<p class="hk-count"></p>';
    f.parentNode.insertBefore(wrap, f.nextSibling);
    renderCounts();
  }

  /* ---------- cart: shipping line + countdown above checkout ---------- */
  function cartInserts() {
    var btns = document.querySelectorAll('[name="checkout"]');
    var added = false;
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      /* Do NOT flag the button. Horizon's morph reuses the button node while
         replacing its siblings, so a flag on the button outlives the box it was
         meant to describe and the line never comes back after a cart update.
         Ask whether the box is actually there instead. */
      var prev = btn.previousElementSibling;
      if (prev && prev.className && prev.className.indexOf("hk-cartextras") > -1) continue;
      added = true;
      var box = document.createElement("div");
      box.className = "hk-cartextras";
      box.innerHTML = '<p class="hk-shipline"></p><p class="hk-count"></p>';
      btn.parentNode.insertBefore(box, btn);
    }
    if (!added) return false;
    renderCounts();
    paintShipLine();          /* paint from cache if we have it */
    readCart(paintShipLineFrom); /* and refresh once */
    return true;
  }
  function paintShipLineFrom(cart) { lastCart = cart; paintShipLine(); }
  function paintShipLine() {
    if (!lastCart) return;
    var els = document.querySelectorAll(".hk-shipline");
    var free = lastCart.total_price >= FREE_SHIP_CENTS;
    /* Struck through only once it is genuinely not being charged. $10 is the
       live Domestic rate under $65, so above the threshold this is a real saving
       the shopper has earned, not an invented one. Below it they are about to
       pay it and the line says so. */
    /* Owner call, 8 Aug: say nothing about shipping until it is free.
       Announcing a $10 flat fee on the cart is a reason to hesitate at the exact
       moment we want none, and Shopify states the real cost at checkout anyway,
       so nothing is hidden from the shopper, it is just not volunteered early.
       hk-ship-nudge still tells them how far they are from free shipping, which
       is the same fact framed as progress rather than a charge. */
    var html = free ? 'Post <strong>FREE</strong>' : "";
    for (var i = 0; i < els.length; i++) {
      if (els[i].innerHTML !== html) els[i].innerHTML = html;
      els[i].hidden = !free;
    }
  }

  /* ---------- sticky bar (mobile) ---------- */
  var bar = null, barState = null, hasPaid = false, form = null;

  /* The bar is the product page's own buy button. Other pages carry /cart/add
     forms too: the cart page and the collections render a quick-add form inside
     every product card, and binding to one of those gave the cart page a sticky
     bar whose button acted on a recommended product instead of the cart. Take
     the page's own product form and nothing else. */
  var QUICK = 'quick-add-component, .quick-add, .quick-add__product-form-component';
  function pickMainForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].closest && forms[i].closest(QUICK)) continue;
      return forms[i];
    }
    return null;
  }
  /* Horizon re-renders the product form when the variant changes, which can
     replace the node this file is holding. A detached form still answers
     querySelector, so a stale handle looks like it is working right up until the
     button it hands back is not the one on screen. Re-resolve when it drops out
     of the document. */
  function mainForm() {
    if (form && document.contains(form)) return form;
    form = pickMainForm();
    return form;
  }
  function addBtnEl() {
    var f = mainForm();
    return f ? f.querySelector('[name="add"], button[type="submit"]') : null;
  }
  /* Horizon disables the buy button and relabels it "Sold out" for a variant that
     cannot be bought. The bar has to follow it: left alone it keeps inviting a tap
     that the browser then swallows without a word. */
  function addDisabled() {
    var a = addBtnEl();
    if (!a) return false;
    return !!(a.disabled || a.getAttribute("aria-disabled") === "true");
  }
  function buildBar() {
    if (bar) return;
    form = pickMainForm();
    if (!form) return;
    bar = document.createElement("div");
    bar.id = "hk-bar";
    bar.setAttribute("aria-hidden", "true");
    bar.innerHTML =
      '<div id="hk-bar-upsell" role="region" aria-label="Add another bottle">' +
        '<div id="hk-bar-upsell-row">' +
          '<span id="hk-bar-upsell-text"></span>' +
          '<button id="hk-bar-upsell-btn" type="button" tabindex="-1">Add another</button>' +
        '</div>' +
        /* Small print under the offer. Styled inline rather than in hk-cro.css
           because asset fingerprints on this store get stuck for hours and this
           did not warrant cutting a new stylesheet over one rule. */
        '<div id="hk-bar-upsell-ship" style="font-size:12px;line-height:1.3;opacity:.75;margin-top:2px"></div>' +
        '<div style="display:none">' +
        '</div>' +
        '<div id="hk-bar-upsell-scents" role="group" aria-label="Choose a scent for the second bottle"></div>' +
      '</div>' +
      '<div id="hk-bar-scents" role="group" aria-label="Choose scent"></div>' +
      '<div id="hk-bar-row"><span id="hk-bar-info"></span>' +
      '<button id="hk-bar-btn" type="button" tabindex="-1"></button></div>';
    document.body.appendChild(bar);
    renderBar();   /* paint immediately, do not wait for the cart round trip */
    buildScents();
    document.getElementById("hk-bar-btn").addEventListener("click", function () {
      /* 8 Aug: was /checkout. Jumping straight to Shopify checkout skipped the
         cart entirely, and the cart is where the second and third bottle offers
         live. Nothing can be added once checkout has them. */
      if (hasPaid) { track("HK_StickyToCart"); window.location.href = "/cart"; return; }
      var add = addBtnEl();
      /* A disabled button swallows a synthetic click in silence. Firing the pixel
         before the click meant every dead tap on a sold out scent was recorded as
         intent, which is part of why AddToCart ran so far ahead of orders. Repaint
         instead, so the shopper sees the real state and can pick another scent. */
      if (!add || add.disabled || add.getAttribute("aria-disabled") === "true") {
        renderBar();
        return;
      }
      track("HK_StickyATC");
      add.click();
    });
    document.getElementById("hk-bar-upsell-btn").addEventListener("click", openChooser);
  }

  /* ---------- upsell row ---------- */
  /* Shown only when the cart holds exactly one single bottle and nothing else
     paid, because that is the only state where a second bottle triggers the pack
     swap. Two singles never sit there long (hk-pack-upgrade swaps them), and a
     cart that already holds a pack has nothing to upsell from here. */
  var upselling = false, upsellText = null;
  /* 2 = offering a second bottle, 3 = offering a third. Drives the chooser
     wording and what a tap actually adds. */
  var upsellStep = 2;

  function singleSummary(cart) {
    var tbl = window.HK_PACK && window.HK_PACK.SINGLES;
    if (!tbl) return null;                       /* pack script absent: offer nothing */
    var singles = 0, singleId = null, unitPrice = 0, otherPaid = 0;
    /* v5: packs are counted too, so the row can tell "one bottle" from "a two
       pack" and offer the right next rung. PACK_CONTENTS maps a pack variant
       back to the scents inside it. */
    var packBottles = 0, packLines = 0, packId = null;
    var contents = (window.HK_PACK && window.HK_PACK.PACK_CONTENTS) || {};
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var line = it.final_line_price != null ? it.final_line_price : it.line_price;
      if (tbl[it.variant_id]) {
        singles += it.quantity;
        singleId = it.variant_id;
        unitPrice = it.final_price != null ? it.final_price : it.price;
      } else if (contents[it.variant_id]) {
        packBottles += contents[it.variant_id].length * it.quantity;
        packLines += 1;
        packId = it.variant_id;
      } else if (line > 0) {
        otherPaid += it.quantity;
      }
    }
    return { singles: singles, singleId: singleId, unitPrice: unitPrice, otherPaid: otherPaid,
             packBottles: packBottles, packLines: packLines, packId: packId, total: cart.total_price };
  }

  var upsellId = null;
  function renderUpsell(cart) {
    var host = document.getElementById("hk-bar-upsell");
    if (!host) return;
    var s = singleSummary(cart);
    var text = null, shipText = null;
    if (s && s.singles === 1 && s.otherPaid === 0 && s.unitPrice > 0) {
      loadStock();
      var save = window.HK_PACK.SAVE2_CENTS;
      /* Everything quoted is derived, never asserted: the pack total is what the
         swap will actually produce, so the free shipping clause only appears when
         it is true on both sides. */
      var packTotal = (2 * s.unitPrice) - save;
      var unlocks = s.total < FREE_SHIP_CENTS && packTotal >= FREE_SHIP_CENTS;
      upsellId = s.singleId;
      upsellStep = 2;
      /* Nothing left to sell them: every single bottle is out of stock. Offering
         the row anyway would open a chooser with no options in it. */
      if (stock && !availableSingles().length) { upsellId = null; }
      else {
        text = "Add another bottle and save " + money(save);
        shipText = unlocks ? "+ free shipping" : null;
      }
    } else if (s && s.packLines === 1 && s.packBottles === 2 && s.singles === 0 && s.otherPaid === 0) {
      /* They took the two pack. Nothing offered a third before this, so the bar
         went quiet at the moment they had just proved they would buy again.
         The saving needs no price lookup: the step from two pack to three pack
         costs (3u - SAVE3) - (2u - SAVE2), so against another single at u they
         keep SAVE3 - SAVE2 exactly, whatever u is. */
      loadStock();
      upsellStep = 3;
      upsellId = s.packId;
      /* The owner's call, 8 Aug: quote the total saving against three singles,
         which is what the pack toast already says, not the $14.99 increment. */
      var save3 = window.HK_PACK.SAVE3_CENTS;
      /* The two pack price in the cart gives us the unit price without a lookup:
         total = 2u - SAVE2, so u = (total + SAVE2) / 2, and the three pack lands
         at 3u - SAVE3. Derived, so it cannot drift from the variant tables. */
      var unit3 = (s.total + window.HK_PACK.SAVE2_CENTS) / 2;
      var packTotal3 = (3 * unit3) - window.HK_PACK.SAVE3_CENTS;
      if (stock && !availableSingles().length) upsellId = null;
      else {
        text = "Add a third and save " + money(save3) + ". Free Express Post included.";
        /* Owner's call, 8 Aug: do not repeat a benefit they already hold. The
           two pack is $70.00 and the threshold is $65.00 on the product total, so
           anyone being offered a third already ships free. This is the same test
           the first rung uses, not a special case, so it starts showing again by
           itself if the numbers ever change. */
        shipText = (s.total < FREE_SHIP_CENTS && packTotal3 >= FREE_SHIP_CENTS)
          ? "+ free shipping" : null;
      }
    } else {
      upsellId = null;
    }
    if (text === upsellText) return;
    upsellText = text;
    var ship = document.getElementById("hk-bar-upsell-ship");
    if (ship) ship.textContent = text && shipText ? shipText : "";
    var span = document.getElementById("hk-bar-upsell-text");
    var btn = document.getElementById("hk-bar-upsell-btn");
    if (text) {
      if (span) span.textContent = text;
      if (btn) { btn.disabled = false; btn.textContent = "Add another"; }
      host.className = "show";
    } else {
      host.className = "";
    }
    publishBarHeight();
  }

  /* Stock for the single bottles, so the chooser never offers a scent that cannot
     be bought. Loaded lazily the first time the upsell row is actually shown, not
     on every product view: most sessions never reach the one bottle state, and by
     the time anyone taps "Add another" the answer is already here. One request,
     once, no polling. The product URL comes off the theme's own form component
     rather than a handle written down again here. */
  var stock = null, stockLoading = false;
  function loadStock() {
    if (stock || stockLoading) return;
    var el = document.querySelector("[data-product-url]");
    var url = el && el.getAttribute("data-product-url");
    if (!url) return;
    stockLoading = true;
    fetch(url + ".js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (p) {
        stockLoading = false;
        if (!p || !p.variants) return;
        var map = {};
        for (var i = 0; i < p.variants.length; i++) map[p.variants[i].id] = !!p.variants[i].available;
        stock = map;
        if (lastCart) renderUpsell(lastCart);   /* re-render in case everything is out */
      })
      .catch(function () { stockLoading = false; });
  }
  /* Unknown stock means show everything: a chooser that hides options because a
     request failed is worse than one that offers a scent and says it sold out. */
  function availableSingles() {
    var list = (window.HK_PACK && window.HK_PACK.SINGLE_LIST) || [];
    if (!stock) return list;
    var out = [];
    for (var i = 0; i < list.length; i++) if (stock[list[i].id] !== false) out.push(list[i]);
    return out;
  }

  /* "Add another" opens a scent choice rather than silently duplicating whatever
     is already in the cart. Owner's call, 8 Aug: the second bottle is the chance
     to try a different scent, and picking for them quietly wastes it. The options
     come from HK_PACK.SINGLE_LIST so the variant ids are not written down twice.
     Any pair of scents has a two pack variant, so every choice can be honoured. */
  function openChooser() {
    if (upselling || !upsellId) return;
    var host = document.getElementById("hk-bar-upsell");
    var strip = document.getElementById("hk-bar-upsell-scents");
    var label = document.getElementById("hk-bar-upsell-text");
    var list = availableSingles();
    /* No list means the pack script is an older build. Fall back to the previous
       one tap behaviour rather than offering a chooser with nothing in it. */
    /* On the third rung upsellId is the PACK in the cart, not something to add.
       Adding it would give them a second two pack. */
    if (!host || !strip || !list.length) {
      if (upsellStep === 3) { if (list.length) addScent(list[0].id); }
      else addScent(upsellId);
      return;
    }
    track("HK_UpsellOpen");
    strip.innerHTML = "";
    for (var i = 0; i < list.length; i++) {
      (function (item) {
        var b = document.createElement("button");
        b.type = "button";
        /* The scent already in the cart is marked, not hidden: two of the same is
           a normal choice and the pack table has a variant for it. */
        b.className = "hk-scent" + (item.id === upsellId ? " is-on" : "");
        b.textContent = shortName(item.name);
        b.addEventListener("click", function () { addScent(item.id); });
        strip.appendChild(b);
      })(list[i]);
    }
    var shipEl = document.getElementById("hk-bar-upsell-ship");
    if (shipEl) shipEl.textContent = "";
    if (label) label.textContent = upsellStep === 3
      ? "Which scent for the third bottle?"
      : "Which scent for the second bottle?";
    host.className = "show is-choosing";
    publishBarHeight();
  }

  function closeChooser() {
    var host = document.getElementById("hk-bar-upsell");
    if (host && host.className.indexOf("is-choosing") > -1) host.className = "show";
    upsellText = null;          /* force the next renderUpsell to repaint the offer */
    publishBarHeight();
  }

  /* A single sitting next to a pack means the swap did not happen. Remove it and
     say so, rather than leaving a cart that quietly costs $14.99 more. */
  function rollbackLooseSingle(label) {
    /* v2.3: retired. HKCartQ converts atomically inside its queue, so a loose single
       next to a pack can no longer be left behind, and a second writer here would
       race it. */
    if (window.HKCartQ) return;
    readCart(function (cart) {
      var s = singleSummary(cart);
      if (!s || s.singles < 1 || s.packLines < 1) return;
      var tbl = window.HK_PACK && window.HK_PACK.SINGLES;
      var key = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (tbl && tbl[cart.items[i].variant_id]) { key = cart.items[i].key; break; }
      }
      if (!key) return;
      /* change.js validates the id against \A\d+\z or \A\d+:[a-f0-9]{32}\z,
         so the line key is passed, never a number. See CART-FIXES-2026-08-08. */
      fetch("/cart/change.js", {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function (r) {
        if (!r || !r.ok) { try { if (window.console) console.warn("hk-cro: rollback rejected", r && r.status); } catch (e) {} return; }
        track("HK_UpsellRolledBack");
        upsellText = null;
        if (label) label.textContent = "That three pack just sold out.";
        readCart(applyPaid);
      }).catch(function () {});
    });
  }

  function addScent(id) {
    if (upselling || !id) return;
    upselling = true;
    var label = document.getElementById("hk-bar-upsell-text");
    if (label) label.textContent = "Adding\u2026";
    /* 8 Aug: without this the row froze on "Adding". renderUpsell compares the
       offer it is about to paint against upsellText and returns early when they
       match, so a transient label written straight into the DOM was never
       replaced and the button looked dead. */
    upsellText = null;
    var step = upsellStep;
    track("HK_UpsellAdd");
    /* v2.3: the one cart queue owns every write (hk-cart-core-v1.js). It adds the
       bottle and applies the pack price in one request, so no evaluate() call or
       rollback timer is needed. This bar is hidden on v2 (hkv2-chrome.css), kept
       working for any page that still shows it. */
    if (window.HKCartQ) {
      window.HKCartQ.add([{ id: id, quantity: 1 }]).then(function () { track("HK_UpsellAdded"); }, function () {
        if (label) label.textContent = "That scent just sold out. Try another.";
      }).then(function () { upselling = false; setTimeout(function () { closeChooser(); readCart(applyPaid); }, 600); });
      return;
    }
    fetch("/cart/add.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      upselling = false;
      if (r && r.ok) {
        track("HK_UpsellAdded");
        /* Ask the pack script directly rather than firing cart:update, which this
           file is not allowed to dispatch. It swaps the two singles for the pack,
           toasts the saving, and fires cart:update itself, which brings us back
           through applyPaid and clears this row. */
        if (window.HK_PACK && window.HK_PACK.evaluate) window.HK_PACK.evaluate();
        /* Only 4 of the 20 three packs are buyable today. If the swap declines,
           the shopper is left holding a two pack plus a loose single, which is
           $109.99 for what costs $95.00 as a pack. Put it back rather than let
           them pay the difference. */
        if (step === 3) setTimeout(function () { rollbackLooseSingle(label); }, 3200);
      } else if (label) {
        /* Nearly always a scent that has just sold out. Say so, rather than
           leaving a chip that looks like it did nothing. */
        label.textContent = "That scent just sold out. Try another.";
      }
      /* Re-read regardless. If the pack variant is sold out the swap declines
         silently, and without this the row would sit on a stale count. */
      setTimeout(function () { closeChooser(); readCart(applyPaid); }, 1800);
    }).catch(function () {
      upselling = false;
      closeChooser();
      readCart(applyPaid);
    });
  }

  /* Mirror the page's own scent inputs. Never a second source of truth. */
  function scentInputs() {
    var out = [];
    var inputs = document.querySelectorAll('fieldset input[type="radio"], variant-picker input[type="radio"], .variant-option input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      if (inp.disabled) continue;
      /* Horizon marks a sold out option here, not with the disabled attribute. */
      var avail = inp.getAttribute("data-option-available");
      if (avail === "false") continue;
      var lab = document.querySelector('label[for="' + inp.id + '"]');
      if (!lab && inp.closest) lab = inp.closest('.variant-option__button-label, label');
      var text = lab ? (lab.textContent || '').trim() : (inp.value || '');
      if (!text) continue;
      /* skip anything that is not a scent, for example a pack size option */
      if (/bottle|pack/i.test(text)) continue;
      out.push({ input: inp, label: text });
    }
    return out;
  }
  function shortName(s) {
    return s.replace(/\s*\+\s*/g, ' + ').replace(/Lemon Myrtle \+ Eucalyptus/i, 'Lemon Myrtle')
            .replace(/Mandarin Peel \+ Rosemary/i, 'Mandarin').replace(/Peppermint \+ Pine Needle/i, 'Peppermint')
            .replace(/Fragrance Free/i, 'Fragrance free');
  }
  /* One scent selector means a single bottle: safe to mirror. More than one means
     a pack where each bottle has its own scent, and a flat row would silently drive
     only the first one. In that case show nothing. */
  function scentFieldsetCount() {
    var sets = document.querySelectorAll('fieldset');
    var n = 0;
    for (var i = 0; i < sets.length; i++) {
      var radios = sets[i].querySelectorAll('input[type="radio"]');
      if (!radios.length) continue;
      var txt = (sets[i].textContent || '');
      if (/bottle|pack/i.test(txt) && !/scent|myrtle|mandarin|peppermint|fragrance/i.test(txt)) continue;
      n++;
    }
    return n;
  }
  function scentSignature() {
    var list = scentInputs();
    var s = [];
    for (var i = 0; i < list.length; i++) s.push(list[i].label);
    return s.join('|');
  }
  function buildScents() {
    var host = document.getElementById("hk-bar-scents");
    if (!host) return;
    if (scentFieldsetCount() !== 1) { host.style.display = "none"; return; }
    var sig = scentSignature();
    if (host.__sig === sig) return;      /* nothing changed, leave it alone */
    host.__sig = sig;
    var list = scentInputs();
    if (list.length < 2) { host.style.display = "none"; return; }
    if (!hasPaid) host.style.display = "";
    host.innerHTML = "";                  /* rebuild from the current truth */
    for (var i = 0; i < list.length; i++) {
      (function (item) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "hk-scent" + (item.input.checked ? " is-on" : "");
        b.textContent = shortName(item.label);
        b.addEventListener("click", function () {
          item.input.click();
          setTimeout(syncScents, 120);
        });
        host.appendChild(b);
      })(list[i]);
    }
    publishBarHeight();
  }
  function syncScents() {
    var host = document.getElementById("hk-bar-scents");
    if (!host || !host.__sig) return;
    var list = scentInputs();
    var btns = host.querySelectorAll(".hk-scent");
    for (var i = 0; i < btns.length && i < list.length; i++) {
      btns[i].className = "hk-scent" + (list[i].input.checked ? " is-on" : "");
    }
  }

  function priceText() {
    var qty = document.querySelector(".hk-pack.is-current .hk-pack__qty");
    var price = document.querySelector(".hk-pack.is-current .hk-pack__price");
    var p = "";
    if (price) { for (var n = price.firstChild; n; n = n.nextSibling) if (n.nodeType === 3) p += n.textContent; p = p.replace(/s+/g, " ").trim(); }
    if (qty && p) return qty.textContent + ", " + p;
    if (p) return p;
    return "";
  }
  var labelTries = 0;
  function renderBar() {
    if (!bar) return;
    var sold = !hasPaid && addDisabled();
    var state = hasPaid ? "checkout" : (sold ? "soldout" : "add");
    if (state === barState) {
      /* same state, but the price label may have been empty when we first painted */
      if (!hasPaid && labelTries < 5) {
        var info0 = document.getElementById("hk-bar-info");
        if (info0 && !info0.textContent) { labelTries++; info0.textContent = priceText(); }
      }
      return;
    }
    barState = state;
    var info = document.getElementById("hk-bar-info");
    var btn = document.getElementById("hk-bar-btn");
    var scentHost = document.getElementById("hk-bar-scents");
    if (hasPaid) {
      /* the choice is made, the chips are just noise now */
      if (scentHost) scentHost.style.display = "none";
      info.textContent = "Free post on 2 and 3 bottle packs";
      btn.textContent = "Go to cart";
      btn.className = "is-checkout";
      btn.disabled = false;
      btn.style.background = ""; btn.style.opacity = ""; btn.style.cursor = "";
    } else if (sold) {
      /* Keep the chips up. They already exclude sold out scents, so the way out of
         this state is one tap and it is sitting right above the button. */
      if (scentHost && scentHost.__sig) scentHost.style.display = "";
      info.textContent = "Choose another scent";
      btn.textContent = "Sold out";
      btn.className = "is-soldout";
      btn.disabled = true;
      /* Styled from here rather than hk-cro-v3.css: asset fingerprints on this
         store stick for hours and one rule does not warrant cutting a new sheet. */
      btn.style.background = "#9a9a9a"; btn.style.opacity = ".9"; btn.style.cursor = "default";
    } else {
      if (scentHost && scentHost.__sig) scentHost.style.display = "";
      info.textContent = priceText();
      btn.textContent = "Add to cart";
      btn.className = "";
      btn.disabled = false;
      btn.style.background = ""; btn.style.opacity = ""; btn.style.cursor = "";
    }
    publishBarHeight();
  }
  function applyPaid(cart) {
    var paid = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var price = it.final_line_price != null ? it.final_line_price : it.line_price;
      if (price > 0) paid += it.quantity;
    }
    hasPaid = paid > 0;
    renderBar();
    renderUpsell(cart);
    paintShipLine();
  }
  function drawerOpen() {
    return !!document.querySelector('dialog[open], cart-drawer[open], .cart-drawer[open], [data-cart-drawer][open]');
  }

  /* The bar's height drives two other fixed elements: the back to top button and
     the free shipping nudge. Both used to hardcode 68px, which was wrong the
     moment the scent strip or the upsell row was showing, so the back to top
     button sat underneath the bar. Publish the measured height instead and let
     the CSS offset from it. DOM reads only, and only when something changed. */
  var lastBarH = -1;
  var barRaf = null;
  function publishBarHeight() {
    /* Callers fire after DOM writes; one read per turn keeps layout from being
       forced on every call. A timer rather than an animation frame, so a tab
       the browser treats as hidden still gets its measurement. */
    if (barRaf) return;
    barRaf = setTimeout(function () { barRaf = null; measureBar(); }, 0);
  }
  function measureBar() {
    if (!bar) return;
    var h = bar.className === "show" ? bar.offsetHeight : 0;
    if (h === lastBarH) return;
    lastBarH = h;
    document.documentElement.style.setProperty("--hk-bar-h", h + "px");
    /* Nothing offsets the page for a fixed bar, so whatever sits last on a page
       hides underneath it. --hk-bar-h only ever reached the ship nudge and the
       back to top button; the document itself was never given the room. */
    if (document.body) document.body.style.paddingBottom = h ? h + "px" : "";
  }

  /* Always on. The bar is the buy button for the whole page, not a thing that
     appears once you have scrolled far enough to lose the real one. DOM only,
     never touches the network. */
  var lastShow = null, atcInView = false, atcWatched = false;
  function watchAtc() {
    if (atcWatched || !form || !window.IntersectionObserver) return;
    var btn = form.querySelector('button[type="submit"], [name="add"]');
    if (!btn) return;
    atcWatched = true;
    new IntersectionObserver(function (entries) {
      atcInView = entries[0].isIntersecting;
      positionBar();
    }, { threshold: 0.4 }).observe(btn);
  }
  function positionBar() {
    watchAtc();
    if (!bar || !form) return;
    var show = !drawerOpen() && !atcInView;
    if (show === lastShow) return;      /* scroll fires constantly, this does not */
    lastShow = show;
    bar.className = show ? "show" : "";
    bar.setAttribute("aria-hidden", show ? "false" : "true");
    var btn = document.getElementById("hk-bar-btn");
    if (btn) { btn.tabIndex = show ? 0 : -1; }
    var up = document.getElementById("hk-bar-upsell-btn");
    if (up) { up.tabIndex = show ? 0 : -1; }
    publishBarHeight();
  }

  /* ---------- dispatch countdown ----------
     Weekdays before 2pm Sydney time: "Order in the next Xh Ym and it ships today".
     After the cut-off it names the next business day. Public holidays are not
     modelled; the owner can hold orders on those days. */
  function sydneyNow() {
    try { var p = new Intl.DateTimeFormat("en-AU", { timeZone: "Australia/Sydney", hour12: false, weekday: "short", hour: "2-digit", minute: "2-digit" }).formatToParts(new Date()); var o = {}; p.forEach(function (x) { o[x.type] = x.value; }); return { day: o.weekday, h: parseInt(o.hour, 10) % 24, m: parseInt(o.minute, 10) }; } catch (e) { return null; }
  }
  function dispatchText() {
    /* 17 Oct 2026: use the holiday-aware product page logic (window.HKDX in hkv2-pages.js) when loaded */
    if (window.HKDX) { try { return window.HKDX.text(Date.now()).text; } catch (e) {} }
    var n = sydneyNow(); if (!n) return "Order by 2pm weekdays, ships same day.";
    var weekday = ["Mon", "Tue", "Wed", "Thu", "Fri"].indexOf(n.day) > -1;
    var mins = (14 * 60) - (n.h * 60 + n.m);
    if (weekday && mins > 0) { var h = Math.floor(mins / 60), m = mins % 60; return "Order in the next " + (h ? h + "h " : "") + m + "m and it ships today."; }
    if (n.day === "Fri" || n.day === "Sat" || n.day === "Sun") return "Order now and it ships Monday.";
    return "Order now and it ships tomorrow.";
  }
  function paintDispatch() {
    /* 17 Oct 2026: Theme settings > HomeKind stock and dispatch > dispatch countdown off: no live countdown in the bar either */
    if (window.HKDX_OFF) return;
    /* rich text blocks cannot carry a class, so the sentence is found by its text */
    /* v2 preview: matches the new announcement wording (28 Sep 2026) */
    var PHRASE = "Order by 2pm weekdays, ships same day";
    var cands = document.querySelectorAll("strong, span, p.announcement-bar__text");
    for (var c = 0; c < cands.length; c++) {
      var el = cands[c], txt = el.textContent.replace(/^\s+/, "");
      if (el.classList.contains("hk-dispatch") || el.children.length || txt.indexOf(PHRASE) !== 0) continue;
      el.classList.add("hk-dispatch");
      el.setAttribute("data-hk-suffix", txt.slice(PHRASE.length).replace(/\s+$/, ""));   /* ", tracked Australia wide" or "." */
    }
    var els = document.querySelectorAll(".hk-dispatch"); if (!els.length) return;
    var base = dispatchText().replace(/\.$/, "");
    for (var i = 0; i < els.length; i++) {
      var suffix = els[i].getAttribute("data-hk-suffix") || ".";
      var t = base + (suffix.charAt(0) === "," || suffix.charAt(0) === "." ? suffix : " " + suffix);
      if (els[i].textContent !== t) els[i].textContent = t;
    }
  }
  paintDispatch(); setInterval(paintDispatch, 30000);
  document.addEventListener("DOMContentLoaded", paintDispatch);
  document.addEventListener("cart:update", function () { setTimeout(paintDispatch, 1200); });

  /* ---------- wiring ---------- */
  /* The one external trigger. Debounced, and it never re-dispatches. */
  var pending = null;
  document.addEventListener("change", function (e) {
    if (e.target && e.target.type === "radio") {
      setTimeout(syncScents, 100);
      /* Horizon swaps the buy button for the newly chosen variant and that swap
         can land after this event. Bounded re-checks rather than an observer (see
         the HARD RULE at the top); renderBar exits immediately when nothing moved. */
      setTimeout(renderBar, 150);
      setTimeout(renderBar, 600);
      setTimeout(renderBar, 1400);
    }
  });
  document.addEventListener("cart:update", function () {
    setTimeout(cartInserts, 150);   /* the morph may have taken the box with it */
    /* cartInserts returns early once the box exists, and the cart re-read that
       decides whether shipping is free lived inside that early return, so the
       line painted once and then never changed. Refresh it independently. */
    setTimeout(function () { readCart(paintShipLineFrom); }, 500);
    if (pending) clearTimeout(pending);
    pending = setTimeout(function () {
      pending = null;
      cartInserts();
      readCart(applyPaid);
    }, 400);
  });
  document.addEventListener("hk:kit-added", function () {
    if (pending) clearTimeout(pending);
    pending = setTimeout(function () { pending = null; readCart(applyPaid); }, 400);
  });
  window.addEventListener("scroll", positionBar, { passive: true });
  var rz = null;
  window.addEventListener("resize", function () {
    if (rz) clearTimeout(rz);
    rz = setTimeout(function () { rz = null; lastBarH = -1; publishBarHeight(); }, 200);
  }, { passive: true });

  function boot() {
    productInserts();
    buildBar();
    buildScents();
    positionBar();
    cartInserts();
    readCart(applyPaid);
    renderCounts();
    /* A drawer can render after load. Three fixed attempts, then stop. This is
       the bounded replacement for the watcher that took the site down. */
    var tries = 0;
    var late = setInterval(function () {
      tries++;
      buildScents();
      cartInserts();               /* DOM only unless it actually inserted */
      publishBarHeight();
      if (tries >= 5) clearInterval(late);
    }, 1500);
    /* countdown ticks on text alone */
    /* Only writes when the string changes, so a one second tick is free. */
    setInterval(renderCounts, 1000);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
